import { Component } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { Card, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Truncate from 'react-truncate';
import ArrowButton from '../common/button-arrow';
import { MODULE_LEVEL } from '../../data/modules';
import Module from '../common/module';
import rewardStoreImage from '../../assets/img/store_rewards_100.png';
import storeImage from '../../assets/img/store_100.jpg';
import storeMiniChainsImage from '../../assets/img/store_mini_chains_100.png';
import rewardStoreMiniChainsImage from '../../assets/img/store_rewards_mini_chains_100.png';

class Store extends Component {
  selectImage = () => {
    const { hasSelectTheme, outlet: { attributes } } = this.props;

    if (hasSelectTheme) {
      if (attributes['ppc-outlet']) {
        return rewardStoreMiniChainsImage;
      }

      return storeMiniChainsImage;
    }

    if (attributes.reward) {
      return rewardStoreImage;
    }

    return storeImage;
  };

  render() {
    const {
      outlet, registration
    } = this.props;

    const { reward, name, level } = outlet.attributes;

    const details = `/store-details/${outlet.id}`;
    const panelFooter = (
      <div>
        {
          !registration.pending && outlet.attributes['customer-number'] && (
            <div>
              <Link to={details}>
                <ArrowButton
                  className="btn-block"
                  color="red"
                  submit={false}
                >
                  Details
                </ArrowButton>
              </Link>
            </div>
          )}
        {!outlet.attributes['customer-number'] && (
          <div>
            Awaiting approval
            <OverlayTrigger
              overlay={(
                <Tooltip className="tooltip grey" id="tooltip">
                  Please note this store will not be linked to your Ignite
                  account until it has been verified by Imperial Brands
                </Tooltip>
              )}
              placement="bottom"
            >
              <i className="float-end fa fa-info-circle" aria-hidden="true"/>
            </OverlayTrigger>
          </div>
        )}
        {outlet.attributes.reward && (
          <Module name={MODULE_LEVEL}>
            <div className="text-center">
              {level && (
                <span>
                  Store level:
                  {' '}{level}
                </span>
              )}
            </div>
          </Module>
        )}
      </div>
    );

    return (
      <Col sm={12}>
        <img alt="Your rep" className="rep-image user-store" src={this.selectImage()}/>
        <Card className="store-item">
          <Card.Body>
          <div className="store-name">
            <Truncate lines={2}>
              {name.toUpperCase()}
            </Truncate>
          </div>
          {outlet.attributes['customer-number'] && (
            <div className="customer-number padding-b-26">
              Store number {outlet.attributes['customer-number']}
            </div>
          )}
          {outlet.attributes.reward && (
            <Module name={MODULE_LEVEL}>
              {!!level && (
                <span className="customer-number">
                  Store level:
                  <span className="store-name store-level">{' '}{level}</span>
                </span>
              )}
            </Module>
          )}
          {reward && (
            <div className="store-name padding-b-26">
              Reward store
            </div>
          )}
          {!registration.pending && outlet.attributes['customer-number'] && (
            <div>
              <Link to={details} className="store-btn-link padding-b-26">
                View store details
              </Link>
            </div>
          )}
          <div className="user-store">
            {!outlet.attributes['customer-number'] && (
              <span className="store-await">
                Awaiting approval
                <OverlayTrigger
                  overlay={(
                    <Tooltip className="tooltip grey" id="tooltip">
                      Please note this store will not be linked to your Ignite
                      account until it has been verified by Imperial Brands
                    </Tooltip>
                  )}
                  placement="right"
                >
                  <span className="tip">?</span>
                </OverlayTrigger>
              </span>
            )}
          </div>
          </Card.Body>
          <Card.Footer>{panelFooter}</Card.Footer>
        </Card>
        <div className={classnames('reward-footer', {'no-reward': !reward})}>
          {reward && (
            <span>
              <i className="fa fa-gift" aria-hidden="true"/>
              Reward store
            </span>
          )}
        </div>
      </Col>
    );
  }
}

const mapStateToProps = state => ({
  registration: state.registration,
  hasSelectTheme: state.viewConfig.profile.attributes['has-mini-chain-outlet']
});

export default connect(mapStateToProps)(Store);
